'use client'

import React from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'react-i18next'
import { Faq, type FaqItem } from '@/components/site/faq'
import { Reveal } from '@/components/site/reveal'
import { SectionHead } from '@/components/site/section-head'
import { SiteSection } from '@/components/site/section'
import { trackSiteLinkClicked } from '@/lib/analytics'

const QUESTIONS = [
  { question: 'q1', answers: ['a1', 'a1b'] },
  { question: 'q2', answers: ['a2'] },
  { question: 'q3', answers: ['a3'] },
  { question: 'q4', answers: ['a4'] },
  { question: 'q5', answers: ['a5'] },
  { question: 'q6', answers: ['a6'] },
]
export function MeetingNotesFaqSection() {
  const { t } = useTranslation(['web'])
  const items: FaqItem[] = QUESTIONS.map(({ question, answers }) => ({
    key: question,
    question: t(`web:meetingNotesPage.faq.${question}`),
    answers: answers.map((answer) => (
      <Trans
        key={answer}
        t={t}
        i18nKey={`web:meetingNotesPage.faq.${answer}`}
        components={{
          mcp: (
            <Link
              href="/mcp-connector"
              onClick={() => trackSiteLinkClicked('faq', '/mcp-connector')}
              className="border-b border-border text-foreground"
            />
          ),
        }}
      />
    )),
  }))
  return (
    <SiteSection id="faq" divider trackingKey="faq">
      <Reveal>
        <SectionHead
          eyebrow={t('web:meetingNotesPage.faq.eyebrow')}
          titleKey="web:meetingNotesPage.faq.title"
        />
      </Reveal>
      <Reveal className="mt-(--gap-lg)">
        <Faq items={items} />
      </Reveal>
    </SiteSection>
  )
}
